var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30.28 35.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 0a6.79 6.79 0 00-6.78 6.78v2.94h2.21V6.78a4.57 4.57 0 119.13 0v2.94h2.21V6.78A6.78 6.78 0 0015.15 0zm6.77 9.72V13a1.11 1.11 0 11-2.21 0V9.72h-9.13V13a1.11 1.11 0 11-2.21 0V9.72H1a1.1 1.1 0 00-1 1.1v23.47a1.11 1.11 0 001.11 1.11h28.07a1.11 1.11 0 001.1-1.11V10.82a1.1 1.1 0 00-1.1-1.1z",
    fill: "currentColor",
    "data-name": "Layer 2"
  })));
};
export default SvgShoppingBag;